module.exports = __webpack_public_path__ + "img/DE05899.fa458f88.png";